<div appDisableF12Key>
  <router-outlet></router-outlet>
</div>

<!-- MODALS -->
<div class="modal fade" id="statusModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true" #statusModal *ngIf="showPopup">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Confirmation</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <span id="status-msg">Dear User,<br/>
                  Your session is going to expire in 60s and you will be logged out. Please note that your session time is managed by your organization.
                </span>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success update" data-bs-dismiss="modal">OK</button>
            </div>
        </div>
    </div>
</div>